import { cn } from "@/lib/utils";
import { useMusicControls } from "../context/music-controls-context";
import { AnimatedMusicBar } from "./animated-music-bar";

interface IndicatorMusicStatusProps {
  children: React.ReactNode;
  assetId: string;
}

export function IndicatorMusicStatus({ assetId, children }: IndicatorMusicStatusProps) {
  const { status, currentMusicAssetId } = useMusicControls();

  if (currentMusicAssetId !== assetId) {
    return <>{children}</>;
  }

  return (
    <div className="relative">
      <div
        className={cn("absolute z-[1] inset-0 flex items-center justify-center text-white rounded-lg", {
          "opacity-60 bg-black": currentMusicAssetId === assetId && (status === "playing" || status === "paused"),
        })}
      >
        <AnimatedMusicBar active={status === "playing"} />
      </div>
      {children}
    </div>
  );
}
